import { accessRights, authRoles } from './auth/authRoles'

export const Page = Object.freeze({
	dashboard: {
		name: 'Prehľad stavu',
		path: '/dashboard/',
		icon: 'dashboard',
		auth: [authRoles.owner, authRoles.careTaker]
	},
	dashboardByFlat: {
		name: 'Prehľad stavu bytu',
		path: '/dashboard/byFlat/',
		icon: 'dashboard',
		auth: accessRights.housingCooper
	},
	housing_cooperative: {
		name: 'Bytový manažment',
		path: '/housing_cooperative',
		icon: 'maps_home_work_outlined_icon',
		auth: accessRights.careTaker
	},
	water_maters: {
		name: 'Merače',
		path: '/water_maters',
		icon: 'sensors_icon ',
		auth: accessRights.careTaker
	},
	measurement: {
		name: 'Merania',
		path: '/measurement',
		icon: 'table_view',
		auth: accessRights.owner
	},
	alerts: {
		name: 'Upozornenia',
		path: '/alerts',
		icon: 'notifications_active_outlined',
		auth: authRoles.admin
	},
	users: {
		name: 'Používatelia',
		path: '/users',
		icon: 'people',
		auth: authRoles.admin
	},
	profile: {
		path: '/profile'
	},
	documents: {
		name: 'Dokumenty',
		path: '/documentsDownload',
		icon: 'sticky_note_2'
	},
	chirpStack: {
		name: 'ChirpStack',
		path: '/chirpstack',
		icon: 'cloud_queue_icon',
		auth: authRoles.admin
	},
	constAllocation: {
		name: 'Rozúčtovanie nákladov',
		path: '/cost_allocation',
		icon: 'euro_symbol_outlined_icon',
		auth: authRoles.admin
	},
	contact: {
		name: 'Kontakt',
		path: '/contact',
		icon: 'contact_phone'
	}
})
